module.exports = __webpack_public_path__ + "static/media/368.e4dbc19b.svg";